import React from 'react'
import { Link } from 'gatsby'

export const Breadcrumb = ({category, page}) => {

  const Lista = () => {
      return (
      <ul className='breadc'>
        <li><Link to="../">STARTSIDA</Link></li>
        {category ? <li><Link to={`/${category[1]}`}>{category[0]}</Link></li> : null }
        {page ? <li><Link to={`/${page[1]}`}>{page[0]}</Link></li> : null }
      </ul>
      )

  }

  return (
    <div className='section-info bgGrey'><Lista /></div>
  )
}


